export default __webpack_public_path__ + "static/media/Y4SEOFO3SNHCZMJOIWYGPOZD24 1.951d2576.png";